import { Injectable } from '@angular/core';
import { environment } from 'app/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class PractitionerSecretariesAffiliationService {
  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('userTokenId');
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
  }

  list() {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-secretary-practitioner`,
      { headers: this.getHeaders() }
    );
  }

  show(secretaryId: string) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-secretary-practitioner/secretary/${secretaryId}`,
      { headers: this.getHeaders() }
    );
  }

  create(params: any) {
    return this.http.post(
      `${environment.apiUrl}/secretarias-affiliation-secretary-practitioner`,
      params,
      { headers: this.getHeaders() }
    );
  }

  listPractitionerLinkedWithSecretary(secretary_id: Number) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-secretary-practitioner/secretary/${secretary_id}`,
      { headers: this.getHeaders() }
    );
  }

  listByPractitioner(practitioner_id: Number) {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-secretary-practitioner/practitioner/${practitioner_id}`,
      { headers: this.getHeaders() }
    );
  }

  listSecretaries(practitionerId = '1f96bf42-6f6b-4840-bd5f-faad0911ba73') {
    return this.http.get(
      `${environment.apiUrl}/secretarias-affiliation-secretary-practitioner/practitioner/c86b2339-41da-4e91-9ddd-c0edee6a5911`,
      { headers: this.getHeaders() }
    );
  }

  update(affiliationId: string, params: any) {
    return this.http.put(
      `${environment.apiUrl}/secretarias-affiliation-secretary-practitioner/${affiliationId}`,
      params,
      { headers: this.getHeaders() }
    );
  }


}
